import React from 'react';

export const InfoRid = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="50"
    height="48"
    viewBox="0 0 50 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.67"
      d="M48.8119 22.775C51.9995 27.9882 48.1953 36.1205 40.3149 40.939C32.4345 45.7574 23.4621 45.4375 20.2745 40.2243C17.0869 35.0111 20.8911 26.8788 28.7715 22.0603C36.6518 17.2418 45.6242 17.5618 48.8119 22.775Z"
      fill="#E8E6FF"
    />
    <g style={{ mixBlendMode: 'multiply' }} opacity="0.67">
      <path
        d="M40.0618 40.4754C36.2497 48.2595 24.4587 50.3088 13.726 45.0526C2.99321 39.7964 -2.61707 29.2252 1.19505 21.4411C5.00717 13.657 16.7981 11.6078 27.5309 16.8639C38.2636 22.1201 43.8739 32.6913 40.0618 40.4754Z"
        fill="#EFEEF8"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.87088 32.2815L17.4516 17.5626L26.0323 32.2815H8.87088ZM16.0075 15.5297C16.664 14.4035 18.2392 14.4035 18.8957 15.5297L28.4738 31.9594C29.1537 33.1257 28.3439 34.6148 27.0297 34.6148H7.8735C6.55929 34.6148 5.74947 33.1257 6.4294 31.9594L16.0075 15.5297ZM17.5 20.8722C18.1213 20.8722 18.625 21.3945 18.625 22.0389V25.9602C18.625 26.6046 18.1213 27.1269 17.5 27.1269C16.8787 27.1269 16.375 26.6046 16.375 25.9602V22.0389C16.375 21.3945 16.8787 20.8722 17.5 20.8722ZM19.0154 29.6354C19.0154 30.5033 18.3369 31.2069 17.5 31.2069C16.6631 31.2069 15.9846 30.5033 15.9846 29.6354C15.9846 28.7674 16.6631 28.0638 17.5 28.0638C18.3369 28.0638 19.0154 28.7674 19.0154 29.6354Z"
      fill="#5D54C0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29 8.67456V5.24172H32.2955V8.67456H29ZM27 4.72089C27 3.85794 27.6716 3.15839 28.5 3.15839H32.7955C33.624 3.15839 34.2955 3.85794 34.2955 4.72089V8.73363H38.1478C38.9762 8.73363 39.6478 9.43319 39.6478 10.2961V14.3089H43.5C44.3284 14.3089 45 15.0084 45 15.8714V20.3459C45 21.2088 44.3284 21.9084 43.5 21.9084H39.2045C38.376 21.9084 37.7045 21.2088 37.7045 20.3459V16.3331H33.8522C33.0238 16.3331 32.3522 15.6336 32.3522 14.7706V10.7579H28.5C27.6716 10.7579 27 10.0583 27 9.19539V4.72089ZM34.3522 14.2498V10.817H37.6478V14.2498H34.3522ZM39.7045 16.3922V19.825H43V16.3922H39.7045ZM41.1227 4.94905C40.7322 4.54226 40.7322 3.88271 41.1227 3.47591C41.5133 3.06912 42.1464 3.06912 42.537 3.47591L44.7071 5.73649C44.8947 5.93184 45 6.1968 45 6.47306C45 6.74933 44.8947 7.01428 44.7071 7.20963L42.537 9.47021C42.1464 9.87701 41.5133 9.87701 41.1227 9.47021C40.7322 9.06342 40.7322 8.40387 41.1227 7.99708L42.5858 6.47306L41.1227 4.94905Z"
      fill="#5D54C0"
    />
  </svg>
);
